import React from 'react';

const AllianceForum = () => {
  return <h1>AllianceForum Page</h1>;
};

export default AllianceForum;
